import { render, staticRenderFns } from "./SourceOrderNumberLink.vue?vue&type=template&id=57d05d0a&"
import script from "./SourceOrderNumberLink.vue?vue&type=script&lang=js&"
export * from "./SourceOrderNumberLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports